import axios from "axios";

const apiUrl = window.location.origin === 'https://ron.rysun.in:3001' || window.location.origin === 'https://shoptalk.rysun.com' ? 'https://instance_change.rysun.in/' : 'http://43.242.38.46:9006/';
export const http9006 = axios.create({
  baseURL: apiUrl,
});